import type { FaireProductEntity } from "../../entity_types/product";

export const p_qw2kz9vwht: FaireProductEntity = {
  token: "p_qw2kz9vwht",
  type: "product",
  name: "Inlaid CZ Evil Eye Charm 18K Gold Plated S.Steel Necklace - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/359609ec85310c8c575011dfd2866286c2084127d48092012619a6df71ee8e38.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5ba5c18f65cef18e8a781cb01d461669663bb65ab574b7d305405e6b8e7e535.jpeg",
    "https://cdn.faire.com/fastly/7c24c5f4c8575c66c19e101dadacdff4b51485c2653a6ce7d7f308661fe199c8.jpeg",
    "https://cdn.faire.com/fastly/1ceac349cd149762994d445b894190e43ec1d5b96421471ea89d80cc8d25b783.jpeg",
    "https://cdn.faire.com/fastly/2ac1e476bfbbcb252b677c504d3c5a43609bc71c873eaafca152527a8770bd74.jpeg",
    "https://cdn.faire.com/fastly/447e8959ea97e443574a055636799c698ce4a40b0ca026c9980233ea83b0f1f7.jpeg",
    "https://cdn.faire.com/fastly/909195fd926548a72c18ec9514e26fdc759d67a6cb47fbda927212440dceb1b1.jpeg",
    "https://cdn.faire.com/fastly/9d0f7132728417f7020996fa1c80742fb6d8514e34da5e1209f5338d26e57301.jpeg",
    "https://cdn.faire.com/fastly/575e246b0195ae7a18efa32962357114200c74df3dcd4db7050e0d00163d4853.jpeg",
    "https://cdn.faire.com/fastly/bc6261212b4178085b08b7653dd3145b382214662faef431b5cccd6cf9657f9d.jpeg",
    "https://cdn.faire.com/fastly/0c7a09265438db950c7234831401aa2ce25d5b2b1d2f1af175eb9ab56992771b.jpeg",
  ],
  priceDollars: 8,
  description:
    "Type: pendant necklace\nMaterial: 316L Stainless steel，Cubic zirconia，18K gold plated\nSize of pendant : 14~18 mm * 17 ~20mm\nLength of chain : 400mm + 50mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts\n",
  tags: [],
  msrpDollars: 19.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:41.706Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
